import { Injectable, Injector, OnDestroy } from '@angular/core';
import { AbstractComponent } from '../../commons/abstract.component';

@Injectable({ providedIn: 'root' })
export class WavoipService extends AbstractComponent implements OnDestroy {
  private device: any = null;
  private wavoip = null;
  private callEndMonitor: any = null;

  constructor(
    injector: Injector,
  ) {
    super(injector);
  }

  // wavoip-api is only needed when a call starts, so it is loaded on demand.
  private async getDevice(): Promise<any> {
    if (!this.device) {
      const module: any = await import('wavoip-api');
      const WavoipInstance: any = module?.default ?? module;
      this.device = new WavoipInstance();
    }
    return this.device;
  }

  async startDevice(token: string): Promise<void> {
    const device = await this.getDevice();
    const wppInstance = await device.connect(token);

    wppInstance.socket.io.on("error", () => {
      this.alertService.error('Ops! Não é possível fazer a ligação no momento.');
    });

    this.wavoip = wppInstance;
  }

  async startCall(phone: string): Promise<void> {
    if (!!this.wavoip) {
      await this.wavoip.callStart({
        whatsappid: phone,
      });
      
      const originalConsoleLog = console.log;
      console.log = (...args) => {
        const logText = args.join(' ');
        
        if (logText.includes('[*] - Audio stream stopped') || 
            logText.includes('Microfone desconectado e stream parado')) {
          console.log('[WavoipService] Detectada desconexão da chamada pelo cliente');
          
          const event = new CustomEvent('wavoip-call-ended', { detail: { reason: 'client_disconnected' } });
          document.dispatchEvent(event);
        }
        
        if (logText.includes('[AUDIO] - Permission success to access audio device')) {
          console.log('[WavoipService] Detectado que o cliente atendeu a chamada');
          
          const event = new CustomEvent('wavoip-call-answered', { detail: { reason: 'client_answered' } });
          document.dispatchEvent(event);
        }
        
        originalConsoleLog.apply(console, args);
      };
      
      this.callEndMonitor = originalConsoleLog;
    } else {
      this.alertService.info('Ops! Não foi possível fazer a ligação.');
    }
  }

  async endCall(): Promise<void> {
    await this.wavoip.endCall();
    
    if (this.callEndMonitor) {
      console.log = this.callEndMonitor;
      this.callEndMonitor = null;
    }
  }
}